import bProgress from './progress.vue';

export default bProgress;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/progress/progress.js
// module id = 706
// module chunks = 0